import React from 'react'
import CloseButton from 'react-bootstrap/CloseButton'
import CustomBotName from './CustomBotName'

interface IProps {
  //   intent: any
  config: any
  closeModal: () => void
  //   inputJson: any[]
  setConfig: React.Dispatch<React.SetStateAction<any[]>>
  data: any
}

const CustomisationBotNameModal: React.FC<IProps> = ({ config, closeModal, setConfig, data }) => {
  return (
    <div className='card scroll-y w-350px h-350px'>
      <div className='d-flex justify-content-between mx-0 px-0 mb-2'>
        <span className='mb-2 me-auto'>
          {/* <span className='ms-1 badge bg-info fs-5'># {intent.id}</span> */}
        </span>
        <CloseButton onClick={closeModal} />
      </div>
      {/* Render customisation Modal based on intent types
      {!!intent.metadata?.templateId && intent.metadata?.templateId === 11 && (
        <TextWithImage intent={intent} inputJson={inputJson} setInputJson={setInputJson} />
      )} */}
      {!!config && (
        <CustomBotName config={config} setConfig={setConfig} data={data} closeModal={closeModal} />
      )}
    </div>
  )
}

export default CustomisationBotNameModal
